<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14jh2Rn/tc-custom/9781426855740.jpg?1726617321483" alt="This image is the cover for the book Loving Bella, Charity House"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Loving Bella, Charity House
      </h1>
      <p class="bookDescription body article font2">
        <b>She Was Talented, Famous, Successful…</b><br/><br/>But when a scandalous offer ruined it all, Isabella O'Toole escaped her life as a celebrated opera singer and sought refuge in Denver, Colorado. Working as an assistant to Dr. Shane Bartlett is worlds away from her glamorous old life—and she loves it. Loves the work, loves the chance to reconnect with her family and her faith…and slowly begins to love the handsome doctor, as well. Until her dark secret finds her again, threatening her new life—and her chance for Shane's heart.<br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Renee Ryan
      </h2>
      
      <p class="authorDescription body article">&#160;<Br><Br><B>Renee Ryan</B> grew up in a Florida beach town outside Jacksonville, FL.&#160; Armed with a degree in Economics and Religion from Florida State University, she explored various career opportunities, including stints at&#160;a&#160;Florida theme park and a modeling agency.&#160;She currently lives in Savannah, Georgia with her husband and a large, fluffy cat many have mistaken for a small bear.&#160; Renee can be contacted through her website at www.reneeryan.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ea2c6bca